import { ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { ValidationMessageComponent } from '@components/traffic-deviations/components/validation-message/validation-message.component';

@Component({
    selector: 'app-detail-input',
    imports: [ReactiveFormsModule, TranslateModule, ValidationMessageComponent],
    templateUrl: './detail-input.component.html',
    styleUrls: ['./detail-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DetailInputComponent implements OnInit, OnChanges, OnDestroy {
  @Input() control: FormControl;
  @Input() name: string;
  @Input() label: string;
  @Input() type = 'text';
  @Input() placeholder: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['control']) {
      const prev = changes['control'].previousValue as FormControl;
      const curr = changes['control'].currentValue as FormControl;
      if (prev && prev !== curr) {
        prev.removeValidators(Validators.required);
        prev.updateValueAndValidity();
      }
      if (curr) {
        curr.addValidators(Validators.required);
        curr.updateValueAndValidity();
      }
    }
  }

  ngOnInit(): void {
    if (this.control) {
      this.control.addValidators(Validators.required);
      this.control.updateValueAndValidity();
    }
  }

  ngOnDestroy(): void {
    if (this.control) {
      this.control.removeValidators(Validators.required);
      this.control.updateValueAndValidity();
    }
  }
}
